var React = require('react');

function Length (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#434343","fillRule":"nonzero"},[React.createElement("path",{"d":"M1 17h4a1 1 0 0 0 0-2H1a1 1 0 0 0 0 2zM1 22h3a1 1 0 0 0 0-2H1a1 1 0 0 0 0 2zM1 7h4a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2zM1 12h3a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2zM1 27h4a1 1 0 0 0 0-2H1a1 1 0 0 0 0 2z","key":0}),React.createElement("path",{"d":"M0 1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v30a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1zm2 1v28h10V2H2z","key":1})]));
}

Length.defaultProps = {"width":"14","height":"32","viewBox":"0 0 14 32"};

module.exports = Length;

Length.default = Length;
